// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adf-fill-remaining-space {
  flex: 1 1 auto;
}

.adf-full-width {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/components/pdfViewer-password-dialog.scss"],"names":[],"mappings":"AACA;EACI,cAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ","sourcesContent":["@use '@angular/material' as mat;\r\n.adf-fill-remaining-space {\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.adf-full-width {\r\n    width: 100%;\r\n}\r\n\r\n@mixin adf-dialog-theme($theme) {\r\n\r\n    $primary: map-get($theme, primary);\r\n\r\n    .adf-dialog-buttons button {\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .adf-dialog-action-button:enabled {\r\n        color: mat.get-color-from-palette($primary);\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
